// Mock vocabulary data for daily study
export const vocabularyCategories = {
  business: {
    id: 'business',
    name: '商務英語',
    nameSimplified: '商务英语',
    nameEnglish: 'Business English',
    icon: '💼',
    color: 'from-blue-500 to-cyan-500'
  },
  daily: {
    id: 'daily',
    name: '日常生活',
    nameSimplified: '日常生活',
    nameEnglish: 'Daily Life',
    icon: '🏠',
    color: 'from-green-500 to-blue-500'
  },
  travel: {
    id: 'travel',
    name: '旅遊',
    nameSimplified: '旅游',
    nameEnglish: 'Travel',
    icon: '✈️',
    color: 'from-purple-500 to-pink-500'
  },
  food: {
    id: 'food',
    name: '美食',
    nameSimplified: '美食',
    nameEnglish: 'Food',
    icon: '🍽️',
    color: 'from-orange-500 to-red-500'
  },
  technology: {
    id: 'technology',
    name: '科技',
    nameSimplified: '科技',
    nameEnglish: 'Technology',
    icon: '💻',
    color: 'from-indigo-500 to-purple-500'
  }
};

export const vocabularyData = {
  business: [
    {
      id: 'biz_001',
      english: 'negotiate',
      traditional: '談判',
      simplified: '谈判',
      pronunciation: '/nɪˈɡoʊʃieɪt/',
      definition: 'To discuss something with someone in order to reach an agreement',
      example: 'We need to negotiate the terms of the contract.',
      difficulty: 'intermediate',
      image: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=300&fit=crop'
    },
    {
      id: 'biz_002',
      english: 'revenue',
      traditional: '收入',
      simplified: '收入',
      pronunciation: '/ˈrevənjuː/',
      definition: 'Income, especially when of a company or organization',
      example: 'The company\'s revenue increased by 15% this quarter.',
      difficulty: 'intermediate',
      image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=300&fit=crop'
    },
    {
      id: 'biz_003',
      english: 'strategy',
      traditional: '策略',
      simplified: '策略',
      pronunciation: '/ˈstrætədʒi/',
      definition: 'A plan of action designed to achieve a long-term goal',
      example: 'Our marketing strategy focuses on digital platforms.',
      difficulty: 'intermediate',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=300&fit=crop'
    }
  ],
  daily: [
    {
      id: 'daily_001',
      english: 'grocery',
      traditional: '雜貨',
      simplified: '杂货',
      pronunciation: '/ˈɡroʊsəri/',
      definition: 'Food and other items sold in a grocery store',
      example: 'I need to buy groceries for dinner tonight.',
      difficulty: 'beginner',
      image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=400&h=300&fit=crop'
    },
    {
      id: 'daily_002',
      english: 'laundry',
      traditional: '洗衣',
      simplified: '洗衣',
      pronunciation: '/ˈlɔːndri/',
      definition: 'Clothes and linens that need to be washed',
      example: 'I have a lot of laundry to do this weekend.',
      difficulty: 'beginner',
      image: 'https://images.unsplash.com/photo-1517677208171-0bc6725a3e60?w=400&h=300&fit=crop'
    },
    {
      id: 'daily_003',
      english: 'appointment',
      traditional: '預約',
      simplified: '预约',
      pronunciation: '/əˈpɔɪntmənt/',
      definition: 'An arrangement to meet someone at a particular time',
      example: 'I have a doctor\'s appointment at 3 PM.',
      difficulty: 'beginner',
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=400&h=300&fit=crop'
    }
  ],
  travel: [
    {
      id: 'travel_001',
      english: 'itinerary',
      traditional: '行程',
      simplified: '行程',
      pronunciation: '/aɪˈtɪnəreri/',
      definition: 'A planned route or journey',
      example: 'Please send me the travel itinerary for next week.',
      difficulty: 'intermediate',
      image: 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=400&h=300&fit=crop'
    },
    {
      id: 'travel_002',
      english: 'boarding pass',
      traditional: '登機證',
      simplified: '登机证',
      pronunciation: '/ˈbɔːrdɪŋ pæs/',
      definition: 'A document provided by an airline during check-in',
      example: 'Don\'t forget to bring your boarding pass to the gate.',
      difficulty: 'beginner',
      image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=400&h=300&fit=crop'
    }
  ],
  food: [
    {
      id: 'food_001',
      english: 'cuisine',
      traditional: '料理',
      simplified: '料理',
      pronunciation: '/kwɪˈziːn/',
      definition: 'A style or method of cooking',
      example: 'I love Italian cuisine, especially pasta dishes.',
      difficulty: 'intermediate',
      image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=400&h=300&fit=crop'
    },
    {
      id: 'food_002',
      english: 'appetizer',
      traditional: '開胃菜',
      simplified: '开胃菜',
      pronunciation: '/ˈæpətaɪzər/',
      definition: 'A small dish served before the main course',
      example: 'Would you like to order an appetizer?',
      difficulty: 'intermediate',
      image: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d?w=400&h=300&fit=crop'
    }
  ],
  technology: [
    {
      id: 'tech_001',
      english: 'algorithm',
      traditional: '演算法',
      simplified: '算法',
      pronunciation: '/ˈælɡərɪðəm/',
      definition: 'A process or set of rules to be followed in calculations',
      example: 'The search algorithm improves user experience.',
      difficulty: 'advanced',
      image: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=300&fit=crop'
    },
    {
      id: 'tech_002',
      english: 'interface',
      traditional: '介面',
      simplified: '界面',
      pronunciation: '/ˈɪntərfeɪs/',
      definition: 'A point where systems meet and interact',
      example: 'The user interface is very intuitive.',
      difficulty: 'intermediate',
      image: 'https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?w=400&h=300&fit=crop'
    }
  ]
};
